import * as lazyIndex from './lazyIndex';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "SearchActions" */ './lazyIndex')
);

export const lazyStartSearch = new LazyAction(lazyModule, m => m.startSearch);
export const lazyLoadMoreInSearchTable = new LazyAction(lazyModule, m => m.loadMoreInSearchTable);
export const lazylogSearchDone = new LazyImport(lazyModule, m => m.logSearchDone);
export const lazylogSessionEnd = new LazyImport(lazyModule, m => m.logSessionEnd);

export { TableView };
